import CustomStore from 'devextreme/data/custom_store';
import { getMetricsFromOrigin, getStatisticsFromOrigin } from './requestHandler';
let newObj = null;

const instanceParse = (notices) => {
  let instances = []

  notices.forEach(instance => {
    
      if(instance.data !== "null") {
        instances.push(JSON.parse(instance.data))
      }
  })
  
  const combinedData = instances.reduce((result, obj) => {
      const { instance, data } = obj;
      const existingIndex = result.findIndex(item => item.instance === instance);
    
      if (existingIndex === -1) {
        result.push(obj);
      } else {
        // Instance already exists, add workflow counts together
        result[existingIndex].data.forEach((workflow, index) => {
          workflow.count += data[index].count;
        });
      }
    
      return result;
  }, []);
  return combinedData;
}


export const refreshData = () => {
  newObj.component.refresh();
}

export const getGridInstance = (data) => {
  newObj = data;
}

export const dataSource = (url, key) => {
    return new CustomStore({
        loadMode: "raw",
        key: key,
        load: function() {
          return getStatisticsFromOrigin(url).then((resp) => {
            // Use reduce to remove duplicates and add up the count
            const combinedData = Object.values(resp.reduce((acc, obj) => {
              const { instance, count } = obj;
              acc[instance] = acc[instance] ? acc[instance] + count : count;
              return acc;
            }, {})).map((count, index) => ({ instance: Object.keys(resp.reduce((acc, obj) => {
              acc[obj.instance] = true;
              return acc;
            }, {}))[index], count }));
            return combinedData;
          })
        }
    });
}

export const customDataSource = (url, key) => {
    return new CustomStore({
        loadMode: "raw",
        key: key,
        load: function() {
          return getStatisticsFromOrigin(url).then((resp) => {
            let newArray = [];
            let instances = instanceParse(resp); 
            instances.forEach(instance => {
                instance.data.forEach(data => {
                    newArray.push({"instance": instance.instance, "workflow": data.workflow, "count": data.count})
                })
            });
            return newArray;
          })
        }
    });
}


export const metricDataSource = (url) => {
    return getMetricsFromOrigin(url).then((resp) => {
      return resp;
    })
}